function IsHybridApp() {
    return $('#app-data').length > 0;
}

export default IsHybridApp;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/is-hybrid-app.js